export default __webpack_public_path__ + "static/media/estrella_roja.68e96b20.png";